import { Pipe, PipeTransform } from '@angular/core';
import { StatusKind } from '@sb/library/base';
import { RepertoireAssignmentStatus } from '@sb/library/data-models';

@Pipe({name: 'repertoireAssignmentStatus'})
export class RepertoireAssignmentStatusPipe implements PipeTransform {
    transform(status: RepertoireAssignmentStatus | string) {
        if (status === RepertoireAssignmentStatus.Completed) {
            return {
                "status": StatusKind.Success,
                "label": $localize`:@@SPRepertoireAssignmentStatusCompleted:Completed`
            };
        } else if (status === RepertoireAssignmentStatus.InProgress) {
            return {
                "status": StatusKind.Warning,
                "label": $localize`:@@SPRepertoireAssignmentStatusInProgress:In Progress`
            };
        } else if (status === RepertoireAssignmentStatus.Recommended) {
            return {
                "status": StatusKind.Lead,
                "label": $localize`:@@SPRepertoireAssignmentStatusRecommended:Recommended`
            };
        } else if (status === RepertoireAssignmentStatus.Requested) {
            return {
                "status": StatusKind.Default,
                "label": $localize`:@@SPRepertoireAssignmentStatusRequested:Requested`
            };
        } else {
            return {
                "status": StatusKind.Brand,
                "label": "-"
            };
        }
    }
}
